import React from "react";

import { IconButton } from "../inputs/button/IconButton";
import { Stack } from "../layouts/stack/Stack";
import { Theme } from "../theme/Theme";
import { Text } from "./Text";

export interface TagElementProps {
    text: string;
    onDismiss(): void;
}

export const TagElement: React.FunctionComponent<TagElementProps> = (props: TagElementProps) => {
    const handleClick = () => {
        props.onDismiss();
    };

    return (
        <Stack
            horizontal={true}
            tokens={{ childrenGap: 2 }}
            styles={{ root: { width: "auto", background: Theme.palette.themeLighterAlt, alignItems: "center" } }}
        >
            <Text block={false} styles={{ root: { paddingLeft: 10 } }}>
                {props.text}
            </Text>
            <IconButton iconProps={{ iconName: "StatusCircleErrorX" }} onClick={handleClick} />
        </Stack>
    );
};
